import { createAction } from '@reduxjs/toolkit'
import { SearchItem } from '@/types/Page'
import { SearchResult } from '@/components/ui/wizard/Wizard'
import { Moment } from 'moment/moment'
import { RatingValues } from '@/components/ui/wizard/filter/Rating'
import { WizardState } from '@/components/ui/wizard/WizardState'
import { LocationFilterElement } from '../../../domain-config/domain-config'
import { Duration, Month } from '@/types/Search'
import { MapTypesLngLatBounds } from '@/components/ui/search/map-types'
import { StarsValues } from '@/components/ui/wizard/filter/Stars'

export const setLocationFilter = createAction<LocationFilterElement[]>('setLocationFilter')
export const setTranslate = createAction<(s: string) => string>('setTranslate')
export const setSearchBounds = createAction<MapTypesLngLatBounds>('setSearchBounds')
export const setSavedSearchLoaded = createAction<MapTypesLngLatBounds | undefined>(
  'savedSearchLoaded',
)
export const setActiveStep = createAction<number | undefined>('setActiveStep')
export const setSelectedLocationItems = createAction<SearchItem[]>('setSelectedLocationItems')
export const setSelectedTopicItems = createAction<SearchItem[]>('setSelectedTopicItems')
export const setLocationSearchResult = createAction<{
  searchResult: SearchResult[]
  searchTerm: string
}>('setLocationSearchResult')
export const setTopicSearchResult = createAction<{
  searchResult: SearchResult[]
  searchTerm: string
}>('setTopicSearchResult')
export const setTopicSearchTerm = createAction<string>('setTopicSearchTerm')
export const setLocationSearchTerm = createAction<string>('setLocationSearchTerm')
export const setSelectedOptionPeriods = createAction<Month[] | undefined>(
  'setSelectedOptionPeriods',
)
export const toggleSelectedActionPeriods = createAction<Month | undefined>(
  'toggleSelectedActionPeriods',
)
export const setSelectedOptionDuration = createAction<Duration | undefined>(
  'setSelectedOptionDuration',
)
export const setSelectedOptionCalendarFlexibility = createAction<Duration | undefined>(
  'selectedOptionCalendarFlexibility',
)
export const setStartDate = createAction<Moment | undefined>('setStartDate')
export const setEndDate = createAction<Moment | undefined>('setEndDate')
export const setNumberOfGuests = createAction<number>('setNumberOfGuests')
export const resetGuestSearch = createAction('resetGuestSearch')
export const resetTravelPeriodSearch = createAction('resetTravelPeriodSearch')
export const resetLocations = createAction('resetLocations')
export const resetTopic = createAction('resetTopic')
export const setFlexibleTravelPeriodSelected = createAction<boolean>(
  'setFlexibleTravelPeriodSelected',
)
export const setState = createAction<Partial<WizardState>>('setState')
export const setRating = createAction<RatingValues | undefined>('setRatings')
export const setStars = createAction<StarsValues | undefined>('setStars')
export const resetFilters = createAction('resetFilters')
export const resetFiltersExceptGuests = createAction('resetFiltersExceptGuests')

export const setMaximumPrice = createAction<string | undefined>('setMaximumPrice')
export const setOrder = createAction<number | undefined>('setOrder')
